import {
  SlSelect
} from "./chunk.W7ZUVUD7.js";

// src/components/select/select.ts
var select_default = SlSelect;
SlSelect.define("sl-select");

export {
  select_default
};
